/* eslint-disable react/prop-types */ import { Form, useFormikContext } from 'formik';
import React from 'react';
import { ToggleButton } from 'react-bootstrap';
import classnames from 'classnames';
import Control from '../../../components/form/Control';
import ToggleButtonGroup from '../../../components/form/ToggleButtonGroup';
import { softwares } from '../../../components/mapView/constants';
import text from '../../../text';
import ProjectSelectV2 from '../../../components/select/ProjectSelect/ProjectSelectV2';
import { getProjectName } from '../../../utilities/project';
var ProjectDetailsForm = function() {
    var _useFormikContext = useFormikContext(), errors = _useFormikContext.errors, values = _useFormikContext.values, handleChange = _useFormikContext.handleChange, handleBlur = _useFormikContext.handleBlur, touched = _useFormikContext.touched, setFieldValue = _useFormikContext.setFieldValue, setFieldTouched = _useFormikContext.setFieldTouched;
    return /*#__PURE__*/ React.createElement(Form, {
        className: "ProjectDetailsForm"
    }, /*#__PURE__*/ React.createElement("h5", {
        className: "required"
    }, text('project')), /*#__PURE__*/ React.createElement(ProjectSelectV2, {
        value: {
            id: values.projectId,
            name: values.projectName
        },
        onChange: function(option, param) {
            var _param_newProject = param.newProject, newProject = _param_newProject === void 0 ? false : _param_newProject;
            setFieldTouched('projectName');
            if (newProject) {
                setFieldValue('projectId', undefined);
                setFieldValue('projectName', getProjectName(option));
            } else {
                if (option) {
                    setFieldValue('projectId', option.id);
                    setFieldValue('projectName', getProjectName(option));
                } else {
                    // `option` is null if clearing the input field
                    setFieldValue('projectId', undefined);
                    setFieldValue('projectName', undefined);
                }
            }
        },
        hasError: touched.projectName && errors.projectName
    }), /*#__PURE__*/ React.createElement("p", {
        className: classnames('Control-Feedback', {
            isFailed: touched.projectName && errors.projectName
        })
    }, touched.projectName && errors.projectName), /*#__PURE__*/ React.createElement("h5", {
        className: "required"
    }, text('whatSoftwareWillYouUse')), /*#__PURE__*/ React.createElement("div", null, text('selectSoftwareFormat')), /*#__PURE__*/ React.createElement(ToggleButtonGroup, {
        className: "CustomerSoftware",
        type: "radio",
        name: "customer_software"
    }, softwares.result.map(function(key) {
        return /*#__PURE__*/ React.createElement(ToggleButton, {
            variant: "outline-secondary",
            key: key,
            value: key
        }, softwares.entities[key].name);
    })), /*#__PURE__*/ React.createElement("h5", null, text('comments')), /*#__PURE__*/ React.createElement(Control, {
        className: "Message",
        as: "textarea",
        type: "text",
        name: "message",
        rows: 3,
        isFailed: touched.message && !!errors.message,
        value: values === null || values === void 0 ? void 0 : values.message,
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: text('addMessageOptional'),
        validationError: touched.message && errors.message
    }));
};
export default ProjectDetailsForm;
